var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3777 16.8262C10.534 17.0979 9.63316 17.2443 8.69892 17.2443C3.89425 17.2443 0 13.3844 0 8.62217C0 3.8599 3.89425 0 8.69892 0C9.63316 0 10.534 0.146456 11.3777 0.418114C8.79424 2.24412 7.1069 5.24181 7.1069 8.62217C7.1069 12.0025 8.79424 15.0002 11.3777 16.8262Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2443 17.2443C22.0552 17.2443 25.9553 13.3841 25.9553 8.62217C25.9553 3.86028 22.0552 0 17.2443 0C12.4333 0 8.5332 3.86028 8.5332 8.62217C8.5332 13.3841 12.4333 17.2443 17.2443 17.2443Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6533 10.1457C15.1599 6.80424 17.3081 4.53296 20.901 4.08899C20.2772 7.93989 17.7772 9.8186 14.6533 10.1457ZM14.6392 7.9656C14.6392 8.68297 14.522 9.40034 14.2874 10.0943C13.1289 8.38387 12.8428 6.24344 13.5065 4.28528C14.2476 5.36951 14.6392 6.66172 14.6392 7.9656ZM19.7284 12.9778C20.3405 12.9778 20.9385 12.8984 21.5108 12.7418C19.8715 10.6925 17.1768 9.81861 14.651 10.536H14.6369C14.6369 10.55 14.6369 10.5617 14.651 10.5617C14.8855 10.8491 15.1458 11.1225 15.4319 11.3702C16.6303 12.4007 18.1524 12.9755 19.7284 12.9755V12.9778Z",
    fill: "#146706"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.fb6aa380cb4a443dd0154ff15548fb52.svg";
export { ForwardRef as ReactComponent };